import { useQueryParam, StringParam } from "use-query-params";

export const useCountry = () => {
  const [country, setCountry] = useQueryParam("country", StringParam);
  //@ts-ignore
  return [country, setCountry] as const;
};
